import { Component, useEffect, useRef, useState } from "react";
import Chart from "chart.js/auto";
import zoomPlugin from "chartjs-plugin-zoom";
import { connect, useSelector } from "react-redux";
import { updateChartDataFormatAction } from "../../redux/actions/currenciesActions";
import {
    getChartDataFinalRange,
    getChartDataRange,
    getChartDateByDate
} from "../../services/rashTradeServices";
import Calendar from "../../utils/calendar/Calendar";
import { calcLiveProfit, isEven, parisfyData, toFixed } from "../../utils/common-functions";
import { OutSideClickClass, useOutsideClick } from "../../utils/common-hooks";
import { errorToastify } from "../../utils/Toastify";
// import "chartjs-adapter-luxon";

import { connectionClass } from "../../websocket/socket";
import Modal from "../common-components/Modal";
import SelectInput from "../common-components/SelectInput";
import { initChartData, initOptions } from "./chartsData";

class DisplayRenkoSlingData extends Component {
    state = {
        isPreviousDataBeingFetched: false,
        isRequestSent: false,
        calendarData: {
            showCalender: false
        }
    };
    rowIdArray = [];
    renkoClose = [];
    renkoOpen = [];
    stateCounter = true;
    shouldXaAxesGoForward = true;
    shouldMarketPriceChange = false;
    isMarketPriceAdded = false;

    getPreviousData = () => {
        if (!this.state.isRequestSent && this.myChart.config.options.scales.x.min == 0) {
            this.setState(
                {
                    isRequestSent: true
                },
                async () => {
                    const rowIdIndex = this.rowIdArray[0];
                    const { data } = await getChartDataRange({
                        rowIdIndex,
                        rangeDirection: "PREVIOUS",
                        isChartDataFormatRenko: this.props.isChartDataFormatRenko
                    });
                    this.setState({ isRequestSent: false }, async () => {
                        if (data?.row_id.length != 0) {
                            this.shouldXaAxesGoForward = false;
                            data?.date_time.length > 0 && this.placeChartDataOnChartBeginning(data);
                        } else {
                            errorToastify("No more data to be loaded!");
                        }
                    });
                }
            );
        }
    };
    getNextData = async () => {
        if (
            !this.state.isRequestSent &&
            this.myChart.config.options.scales.x.max == this.rowIdArray.length - 1 &&
            !this.props.isRenkoCreationOn
        ) {
            this.setState(
                {
                    isRequestSent: true
                },
                async () => {
                    const rowIdIndex = this.rowIdArray.at(-1);
                    const { data } = await getChartDataRange({
                        rowIdIndex,
                        rangeDirection: "NEXT",
                        isChartDataFormatRenko: this.props.isChartDataFormatRenko
                    });
                    this.setState({ isRequestSent: false }, async () => {
                        if (data?.row_id.length != 0) {
                            data?.date_time.length > 0 && this.placeChartDataOnChart(data);
                        } else {
                            errorToastify("No more data to be loaded!");
                        }
                    });
                }
            );
        }
    };

    findWaveMinMax = () => {
        const chartWave1Data = parisfyData(this.myChart.data.datasets[9].data);
        const chartWave2Data = parisfyData(this.myChart.data.datasets[10].data);
        const chartXMin = this.myChart.config.options.scales.x.min || 0;
        const chartXMax = this.myChart.config.options.scales.x.max || this.rowIdArray.length;
        const sortedWave1 = chartWave1Data?.slice(chartXMin, chartXMax).sort((a, b) => a - b);
        const sortedWave2 = chartWave2Data?.slice(chartXMin, chartXMax).sort((a, b) => a - b);
        const minWave1 = sortedWave1[0];
        const maxWave1 = sortedWave1[sortedWave1.length - 1];
        const minWave2 = sortedWave2[0];
        const maxWave2 = sortedWave2[sortedWave2.length - 1];
        const minWave = minWave1 > minWave2 ? minWave2 : minWave1;
        const maxWave = maxWave1 > maxWave2 ? maxWave1 : maxWave2;
        return { minWave: Math.round(minWave), maxWave: Math.round(maxWave) };
    };

    placeChartDataOnChart = (data) => {
        this.shouldMarketPriceChange = false;
        if (!this.shouldMarketPriceChange && this.props.isBinanceOn) {
            this.myChart.data.labels.pop();
            this.myChart.data.datasets[7].data.pop();
            this.myChart.data.datasets[8].data.pop();
            this.myChart.data.datasets[8].backgroundColor.pop();
        }
        this.addDataToChart(data, "push");
        this.adjustChartScales();
        this.calculateLiveMarketBar();
    };
    placeChartDataOnChartBeginning = (data) => {
        this.addDataToChart(data, "unshift");
        this.adjustChartScales();
        this.calculateLiveMarketBar();
    };

    addDataToChart = (data = [], method) => {
        if (!data?.date_time?.length) return;
        this.myChart.data.labels[method](...data.date_time);
        let mainRenkoData = data.mainRenkoData.map((rd) => rd.value);
        let subRenkoData = data.subRenkoData.map((rd) => rd.value);
        let subRenkoColor = data.subRenkoData.map((rd) => rd.color);
        this.myChart.data.datasets[0].data[method](...data.slingshot1);
        this.myChart.data.datasets[1].data[method](...data.slingshot2);
        this.myChart.data.datasets[2].data[method](...data.moving_average1);
        this.myChart.data.datasets[3].data[method](...data.moving_average2);
        this.myChart.data.datasets[4].data[method](...data.moving_average3);
        this.myChart.data.datasets[5].data[method](...data.moving_average4);
        this.myChart.data.datasets[6].data[method](...data.moving_average5);
        this.myChart.data.datasets[7].data[method](...mainRenkoData);
        this.myChart.data.datasets[7].backgroundColor = this.props.isDarkMode ? "#E4E4F4" : "#fff";
        this.myChart.data.datasets[8].data[method](...subRenkoData);
        this.myChart.data.datasets[8].backgroundColor[method](...subRenkoColor);
        this.myChart.data.datasets[9].data[method](...data.wavetrend1);
        this.myChart.data.datasets[10].data[method](...data.wavetrend2);
        this.renkoOpen[method](...data.renko_open);
        this.rowIdArray[method](...data.row_id);
        this.renkoClose[method](...data.renko_close);
        this.lastRenkoRange = this.myChart.data.datasets[7].data;
    };

    adjustChartScales = () => {
        if (!this.lastRenkoRange.length) return;
        const lastCandleRenkoSize = this.myChart.data.datasets[8].data.at(-1);
        const firstRenkoIndex =
            this.lastRenkoRange?.length > 50 ? this.lastRenkoRange?.length - 50 : 0;
        const minRenkoPipesValue =
            lastCandleRenkoSize * (this.props.isChartDataFormatRenko ? 20 : 10);
        const maxRenkoPipesValue =
            lastCandleRenkoSize * (this.props.isChartDataFormatRenko ? 15 : 10);
        const biggerIndex =
            this.lastRenkoRange[firstRenkoIndex] >
            this.lastRenkoRange[this.lastRenkoRange?.length - 1]
                ? this.lastRenkoRange[firstRenkoIndex]
                : this.lastRenkoRange[this.lastRenkoRange?.length - 1];
        const smallerIndex =
            this.lastRenkoRange[firstRenkoIndex] <
            this.lastRenkoRange[this.lastRenkoRange?.length - 1]
                ? this.lastRenkoRange[firstRenkoIndex]
                : this.lastRenkoRange[this.lastRenkoRange?.length - 1];
        if (this.shouldXaAxesGoForward) {
            this.myChart.options.scales.y2["min"] = smallerIndex - minRenkoPipesValue;
            this.myChart.options.scales.y2["max"] = biggerIndex + maxRenkoPipesValue;
            this.myChart.options.scales.x["min"] = firstRenkoIndex;
            this.myChart.options.scales.x["max"] = this.lastRenkoRange?.length;
        }
        if (!this.shouldXaAxesGoForward) {
            this.myChart.options.scales.y2["min"] =
                this.lastRenkoRange[this.myChart.config.options.scales.x.max] -
                lastCandleRenkoSize * (this.props.isChartDataFormatRenko ? 20 : 10);
            this.myChart.options.scales.y2["max"] =
                this.lastRenkoRange[this.myChart.config.options.scales.x.max] +
                lastCandleRenkoSize * (this.props.isChartDataFormatRenko ? 15 : 10);
        }
        const { maxWave, minWave } = this.findWaveMinMax();
        this.myChart.options.scales.y1["min"] = this.rowIdArray.length > 1 ? minWave : maxWave - 1;
        this.myChart.options.scales.y1["max"] = maxWave;
        this.setState({ dataLength: this?.rowIdArray?.length }, () => {
            this.myChart.update("quiet");
            if (this.props.isBinanceOn) {
                this.shouldMarketPriceChange = true;
            }
        });
    };

    calculateLiveMarketBar = () => {
        if (this.props.isBinanceOn) {
            const dataLength = this.rowIdArray.length;
            const marketPrice = this.props.marketPrice;
            const lastRenkoCloseIndex = this.renkoClose.at(-1) || 0;
            this.myChart.data.labels[dataLength] = "Market Price";
            if (marketPrice >= lastRenkoCloseIndex) {
                this.myChart.data.datasets[7].data[dataLength] = lastRenkoCloseIndex;
                this.myChart.data.datasets[8].data[dataLength] = marketPrice - lastRenkoCloseIndex;
                this.myChart.data.datasets[8].backgroundColor[dataLength] = "#26A69A";
            } else if (marketPrice < lastRenkoCloseIndex) {
                this.myChart.data.datasets[7].data[dataLength] = marketPrice;
                this.myChart.data.datasets[8].data[dataLength] = lastRenkoCloseIndex - marketPrice;
                this.myChart.data.datasets[8].backgroundColor[dataLength] = "#EF5350";
            }
            this.myChart.update("quiet");
        }
    };

    emptyChartValues = () => {
        this.myChart.data.labels = [];
        this.rowIdArray = [];
        this.myChart.data.datasets.map((dataObj) => {
            dataObj.data = [];
        });
        this.myChart.data.datasets.map((dataObj) => {
            dataObj.backgroundColor = [];
        });
        this.myChart.update("quiet");
    };

    drawChevron = (chart) => {
        const {
            ctx,
            chartArea: { left, right, top, bottom, width, height }
        } = chart;
        class CircleChevron {
            // constructor(x1, y1){

            // }
            draw(ctx, x1, pixel) {
                const angle = Math.PI / 180;
                ctx.beginPath();
                ctx.lineWidth = 20;
                ctx.strokeStyle = "rgba(102,102,102,0.5)";
                ctx.fillStyle = "white";
                ctx.arc(x1, height / 2 + top, 15, angle * 360, false);
                ctx.stroke();
                ctx.fill();
                ctx.closePath();
                ctx.beginPath();
                ctx.lineWidth = 3;
                ctx.strokeStyle = "rgba(255,26,104,1)";
                ctx.moveTo(x1 + pixel, height / 2 + top - 7.5);
                ctx.lineTo(x1 - pixel, height / 2 + top);
                ctx.lineTo(x1 + pixel, height / 2 + top + 7.5);

                ctx.stroke();
                ctx.closePath();
            }
        }

        let drawCircleLeft = new CircleChevron();
        drawCircleLeft.draw(ctx, left, 5);
        let drawCircleRight = new CircleChevron();
        drawCircleRight.draw(ctx, right, -5);
    };

    chartMouseDown = (e) => {
        const {
            canvas,
            chartArea: { left, right, top, bottom, width, height }
        } = this.myChart;
        this.setState({ initalClientX: e.clientX }, () => {
            canvas.addEventListener("mouseup", this.chartMouseUp);
            canvas.addEventListener("mousemove", this.chartMouseMove);
        });
        this.myChart.update("");
    };

    chartMouseMove = (e) => {
        const {
            canvas,
            tooltip,
            chartArea: { left, right, top, bottom, width, height }
        } = this.myChart;

        if (e.clientX > this.state.initalClientX) {
            this.shouldXaAxesGoForward = false;
        }
        if (e.clientX < this.state.initalClientX) {
            this.shouldXaAxesGoForward = true;
        }

        if (e.clientX > this.state.initalClientX && e.clientX - this.state.initalClientX > 200) {
            canvas.removeEventListener("mousemove", this.chartMouseMove);
            this.getPreviousData();
        }
        if (e.clientX < this.state.initalClientX && this.state.initalClientX - e.clientX > 200) {
            canvas.removeEventListener("mousemove", this.chartMouseMove);
            this.getNextData();
        }
    };

    chartMouseUp = () => {
        const {
            canvas,
            chartArea: { left, right, top, bottom, width, height }
        } = this.myChart;
        canvas.removeEventListener("mousemove", this.chartMouseMove);
        canvas.removeEventListener("mouseup", this.chartMouseUp);
    };

    getRenkoDateSinceSpecificTime = async () => {
        const renkoSelectedStartDate = this.state.calendarData.renkoSelectedStartDate;
        const { data } = await getChartDateByDate({
            selectedDate: renkoSelectedStartDate,
            isChartDataFormatRenko: this.props.isChartDataFormatRenko
        });
        this.emptyChartValues();
        data?.date_time.length > 0 && this.placeChartDataOnChart(data);
        setTimeout(() => {
            this.myChart.options.scales.x = {
                ...this.myChart.options.scales.x,
                min: 0,
                max: this.rowIdArray.length
            };
            this.myChart.update("quiet");
        }, 200);
    };

    defineFullTbStatus(data) {
        if (data) {
            const total_profit = data?.profit;
            const row_id = toFixed(this.state.fullTbData?.row_id, this.props.decimalNumber || 5);
            if (!isEven(row_id)) {
                const entrySide = data?.status.includes("sell") ? "SELL" : "BUY";
                const totalProfitPercent = calcLiveProfit({
                    candleClosePrice: total_profit,
                    marketPrice: this.props.marketPrice,
                    entrySide,
                    leverage: this.props.leverage,
                    quantity: this.props.quantity,
                    type: "PERCENTAGE"
                });
                data.total_profit = totalProfitPercent;
            } else {
                data.total_profit = this.state?.fullTbData?.total_profit;
            }
            this.setState({ fullTbData: data });
        }
    }

    componentDidMount() {
        const moveChart = {
            id: "moveChart",
            afterEvent(chart, args, pluginOptions) {
                const {
                    ctx,
                    canvas,
                    chartArea: { left, right, top, bottom, width, height }
                } = chart;
                if (canvas)
                    canvas.addEventListener("mousemove", (event) => {
                        const x = args.event.x;
                        const y = args.event.y;
                        if (
                            x >= left - 15 &&
                            x <= left + 15 &&
                            y >= height / 2 + top - 15 &&
                            y <= height / 2 + top + 15
                        ) {
                            canvas.style.cursor = "pointer";
                        } else if (
                            x >= right - 15 &&
                            x <= right + 15 &&
                            y >= height / 2 + top - 15 &&
                            y <= height / 2 + top + 15
                        ) {
                            canvas.style.cursor = "pointer";
                        } else {
                            canvas.style.cursor = "default";
                        }
                    });
            },
            afterDraw(chart, args, pluginOptions) {
                const {
                    ctx,
                    chartArea: { left, right, top, bottom, width, height }
                } = chart;

                class CircleChevron {
                    // constructor(x1, y1){

                    // }
                    draw(ctx, x1, pixel) {
                        const angle = Math.PI / 180;
                        ctx.beginPath();
                        ctx.lineWidth = 3;
                        ctx.strokeStyle = "#EF5350";
                        ctx.fillStyle = "white";
                        ctx.arc(x1, height / 2 + top, 15, angle * 360, false);
                        ctx.stroke();
                        ctx.fill();
                        ctx.closePath();
                        ctx.beginPath();
                        ctx.lineWidth = 3;
                        ctx.strokeStyle = "#EF5350";
                        ctx.moveTo(x1 + pixel, height / 2 + top - 7.5);
                        ctx.lineTo(x1 - pixel, height / 2 + top);
                        ctx.lineTo(x1 + pixel, height / 2 + top + 7.5);

                        ctx.stroke();
                        ctx.closePath();
                    }
                }

                // let drawCircleLeft = new CircleChevron();
                // drawCircleLeft.draw(ctx, left, 5);
                // let drawCircleRight = new CircleChevron();
                // drawCircleRight.draw(ctx, right, -5);
            }
        };
        const ctx = this.chartRef.getContext("2d");
        const myChart = new Chart(ctx, {
            type: "bar",
            data: parisfyData(initChartData),
            options: {
                ...initOptions,

                plugins: {
                    tooltip: {
                        // enabled: false
                        yAlign: "bottom",

                        callbacks: {
                            label: (context) => {
                                const renkoIndex = context.dataIndex;
                                let label = context.dataset.label || "";
                                const renkoRowId = this.rowIdArray[renkoIndex] || "stream";
                                const multistringText = [
                                    `${label}: ${toFixed(
                                        Number(context.raw),
                                        this.props.decimalNumber || 5
                                    )}`
                                ];
                                label === "Main Renko" &&
                                    multistringText.push(`Renko Number ${renkoRowId}`);
                                if (label) {
                                    // return label = `${label}: ${Number(context.raw).toFixed(5)}`;
                                    return multistringText;
                                }
                            }
                        }
                    },
                    zoom: {
                        zoom: {
                            wheel: {
                                enabled: true
                            },
                            pinch: {
                                enabled: true
                            }
                        },
                        pan: {
                            enabled: true
                        }
                    }
                }
            },
            plugins: [zoomPlugin, moveChart]
        });
        this.myChart = myChart;
        this.emptyChartValues();

        const {
            canvas,
            chartArea: { left, right, top, bottom, width, height }
        } = myChart;

        if (canvas) {
            const isDarkMode = this.props.isDarkMode;
            canvas.addEventListener("mousedown", this.chartMouseDown);
            this.myChart.data.datasets[7].backgroundColor = isDarkMode ? "#E4E4F4" : "#fff";
        }
        if (!this.props.isRenkoCreationOn) {
            this.emptyChartValues();
            getChartDataFinalRange(this.props.isChartDataFormatRenko)
                .then((response) => {
                    const { data } = response;
                    data?.date_time.length > 0 && this.placeChartDataOnChart(data);
                })
                .catch((error) => {
                    errorToastify(error);
                });
        }

        if (this.props.isRenkoCreationOn) {
            setTimeout(() => {
                if (this.rowIdArray.length == 0) {
                    getChartDataFinalRange(this.props.isChartDataFormatRenko)
                        .then((response) => {
                            const { data } = response;
                            data?.date_time.length > 0 && this.placeChartDataOnChart(data);
                        })
                        .catch((error) => {
                            errorToastify(error);
                        });
                }
            }, 1000);
            connectionClass.socketInfo.off(`chartData-${this.props.currentCurrencyId}`);
            this.emptyChartValues();
            connectionClass.socketInfo.on(`chartData-${this.props.currentCurrencyId}`, (data) => {
                data?.date_time.length > 0 && this.placeChartDataOnChart(data);
            });
        }
        if (this.props.isModelOn) {
            connectionClass.socketInfo.off(`fullTbData-${this.props.currentCurrencyId}`);
            connectionClass.socketInfo.on(`fullTbData-${this.props.currentCurrencyId}`, (data) => {
                this.defineFullTbStatus(data);
            });
        }

        connectionClass.socketInfo.on(`resetChart-${this.props.currentCurrencyId}`, () => {
            this.emptyChartValues();
        });
        if (this.props.isBinanceOn) {
            setTimeout(() => {
                this.calculateLiveMarketBar();
            }, 1500);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            (this.props.isModelOn &&
                this.props.currentCurrencyId !== prevProps.currentCurrencyId) ||
            (this.props.isModelOn && this.props.isModelOn !== prevProps.isModelOn)
        ) {
            connectionClass.socketInfo.off(`fullTbData-${prevProps.currentCurrencyId}`);
            connectionClass.socketInfo.off(`fullTbData-${this.props.currentCurrencyId}`);
            this.setState({ fullTbData: {} }, () => {
                connectionClass.socketInfo.on(
                    `fullTbData-${this.props.currentCurrencyId}`,
                    (data) => {
                        this.defineFullTbStatus(data);
                    }
                );
            });
        }
        if (!this.props.isModelOn && this.props.currentCurrencyId !== prevProps.currentCurrencyId) {
            connectionClass.socketInfo.off(`fullTbData-${prevProps.currentCurrencyId}`);
            connectionClass.socketInfo.off(`fullTbData-${this.props.currentCurrencyId}`);
        }

        if (this.props.isDarkMode !== prevProps.isDarkMode) {
            this.myChart.data.datasets[7].backgroundColor = this.props.isDarkMode
                ? "#E4E4F4"
                : "#fff";
            this.myChart.update("quiet");
        }

        if (
            this.props.marketPrice !== prevProps.marketPrice &&
            this.props.isBinanceOn &&
            this.shouldMarketPriceChange
        ) {
            this.calculateLiveMarketBar();
        }
        if (this.props.isBinanceOn !== prevProps.isBinanceOn && !this.props.isBinanceOn) {
            this.myChart.data.labels.pop();
            this.myChart.data.datasets[7].data.pop();
            this.myChart.data.datasets[8].data.pop();
            this.myChart.data.datasets[8].backgroundColor.pop();
        }
        if (this.props.isBinanceOn !== prevProps.isBinanceOn && this.props.isBinanceOn) {
            if (!this.props.isModelOn) {
                this.emptyChartValues();
            }
            this.calculateLiveMarketBar();
        }

        if (prevProps.currentCurrencyId != this.props.currentCurrencyId && this.props.isBinanceOn) {
            this.emptyChartValues();
            connectionClass.socketInfo.off(`chartData-${prevProps.currentCurrencyId}`);
            connectionClass.socketInfo.off(`chartData-${this.props.currentCurrencyId}`);
            connectionClass.socketInfo.off(`resetChart-${this.props.currentCurrencyId}`);
            connectionClass.socketInfo.on(`resetChart-${this.props.currentCurrencyId}`, () => {
                this.emptyChartValues();
            });
            connectionClass.socketInfo.on(`chartData-${this.props.currentCurrencyId}`, (data) => {
                data?.date_time.length > 0 && this.placeChartDataOnChart(data);
            });
        }

        if (
            this.props.isRenkoCreationOn &&
            this.props.isRenkoCreationOn != prevProps.isRenkoCreationOn
        ) {
            connectionClass.socketInfo.off(`chartData-${prevProps.currentCurrencyId}`);
            connectionClass.socketInfo.off(`chartData-${this.props.currentCurrencyId}`);
            this.emptyChartValues();
            connectionClass.socketInfo.on(`chartData-${this.props.currentCurrencyId}`, (data) => {
                data?.date_time.length > 0 && this.placeChartDataOnChart(data);
            });
        }

        if (
            !this.props.isRenkoCreationOn &&
            this.props.isRenkoCreationOn != prevProps.isRenkoCreationOn
        ) {
            connectionClass.socketInfo.off(`chartData-${prevProps.currentCurrencyId}`);
        }
        if (
            prevProps.currentCurrencyId != this.props.currentCurrencyId ||
            this.props.isChartDataFormatRenko !== prevProps.isChartDataFormatRenko
        ) {
            connectionClass.socketInfo.off(`chartData-${prevProps.currentCurrencyId}`);
            connectionClass.socketInfo.off(`chartData-${this.props.currentCurrencyId}`);
            this.emptyChartValues();
            getChartDataFinalRange(this.props.isChartDataFormatRenko)
                .then((response) => {
                    const { data } = response;
                    data?.date_time.length > 0 && this.placeChartDataOnChart(data);
                })
                .catch((error) => {
                    errorToastify(error);
                });
        }
    }

    componentWillUnmount() {
        connectionClass.socketInfo.off(`chartData-${this.props.currentCurrencyId}`);
        connectionClass.socketInfo.off(`resetChart-${this.props.currentCurrencyId}`);
        connectionClass.socketInfo.off(`fullTbData-${this.props.currentCurrencyId}`);
        this.myChart.destroy();
    }

    render() {
        return (
            <>
                <div>
                    <div
                        className={`w-full min-h-8 bg-gradient-to-r from-secondaryRed to-secondaryGreen rounded-md text-white flex-col text-sm md:flex-row flex justify-around items-center`}>
                        <div className="flex-1">
                            <OutSideClickClass
                                onClickOutside={() => {
                                    this.setState({
                                        calendarData: {
                                            ...this.state.calendarData,
                                            showCalender: false
                                        }
                                    });
                                }}>
                                <div className="relative flex justify-center">
                                    <div
                                        className={`bg-secondaryGreen px-3 py-1 cursor-pointer rounded-md text-vsm lg:text-sm w-full mt-2 md:mt-0 md:w-1/2 lg:w-1/3 flex justify-center`}
                                        onClick={() =>
                                            !this.props.isRenkoCreationOn &&
                                            this.setState({
                                                calendarData: {
                                                    ...this.state.calendarData,
                                                    showCalender:
                                                        !this.state.calendarData.showCalender
                                                }
                                            })
                                        }>
                                        Select Date
                                    </div>

                                    <Calendar
                                        specificDate={this.props.startRenkoDate}
                                        key={""}
                                        classNames={{
                                            parentDiv: `${
                                                this.state.calendarData.showCalender
                                                    ? "visible"
                                                    : "invisible"
                                            } shadow-2xl top-14 md:top-10   z-10 min-w-28 absolute  text-10   rounded-lg ${
                                                this.props.isDarkMode
                                                    ? "bg-secondaryDark text-[#fff]"
                                                    : "bg-secondaryLight text-[#000]"
                                            }`,
                                            header: {
                                                previous: "flex-1 text-center cursor-pointer",
                                                current: "cursor-pointer flex-5",
                                                next: "cursor-pointer flex-1 text-center ml-1 ",
                                                headerParent: `  text-center h-10 font-black flex items-center  `
                                            },
                                            dayNames: {
                                                holder: `flex bg-black flex-wrap mr-auto items-center  underline`,
                                                dayName: `cursor-pointer flex bg-black font-bold   flex-1 items-center justify-center items-center   text-sm`
                                            },

                                            weekParent: `week my-2 flex flex-wrap mr-auto items-center justify-center`,
                                            dayHolder: ` day rounded-full  ${
                                                this.props.isDarkMode
                                                    ? "hover:bg-tertiaryDark hover:text-[#000]"
                                                    : "hover:bg-white hover:text-black flex justify-center"
                                            }`,
                                            singleDay: " cursor-pointer w-full flex justify-center"
                                        }}
                                        changeOptions={{
                                            classNames: {
                                                parentDiv: `w-full min-h-5  flex flex-row-reverse  justify-around py-2 text-[#fff]`,
                                                positive:
                                                    "bg-primaryGreen py-2 min-w-1/4 rounded-lg",
                                                negative: "bg-primaryRed py-2 min-w-1/4 rounded-lg"
                                            },
                                            btnsText: {
                                                positive: "Save",
                                                negative: "Cancel"
                                            },
                                            btnFuncions: {
                                                positive: (day) => {
                                                    this.setState(
                                                        {
                                                            calendarData: {
                                                                ...this.state.calendarData,
                                                                renkoSelectedStartDate:
                                                                    day.format("M/D/YYYY"),
                                                                showCalender:
                                                                    !this.state.calendarData
                                                                        .showCalender
                                                            }
                                                        },
                                                        () => this.getRenkoDateSinceSpecificTime()
                                                    );
                                                },
                                                negative: () =>
                                                    this.setState({
                                                        calendarData: {
                                                            ...this.state.calendarData,
                                                            showCalender:
                                                                !this.state.calendarData
                                                                    .showCalender
                                                        }
                                                    })
                                            },
                                            btnStatus: {
                                                positive: false,
                                                negative: false
                                            }
                                        }}
                                    />
                                </div>
                            </OutSideClickClass>
                        </div>
                        <div className="flex-1 flex justify-center mt-2 md:mt-0 text-vsm lg:text-sm">
                            Number of Renkos : {this.state.dataLength || 0}
                        </div>
                        <div className="flex-1 flex justify-center mt-2 md:mt-0 text-vsm lg:text-sm">
                            Market Price: {this.props.marketPrice}
                        </div>
                    </div>
                    <div className="w-full mt-2 min-h-8 bg-gradient-to-r from-secondaryRed to-secondaryGreen rounded-md flex-col   text-sm md:flex-row flex items-center text-[#fff] ">
                        <div className="flex-4 flex items-center justify-start px-5 whitespace-nowrap text-vsm lg:text-sm">
                            Status: {this.state.fullTbData?.status}
                        </div>
                        <div className="flex-3 flex items-center justify-start text-vsm lg:text-sm">
                            Current Position : {this.state.fullTbData?.position}
                        </div>
                        <div className="flex-3 flex items-center justify-start text-vsm lg:text-sm">
                            Entry Price :{" "}
                            {toFixed(this.state.fullTbData?.profit, this.props.decimalNumber || 5)}
                        </div>
                        <div className="flex-3 flex items-center justify-start text-vsm lg:text-sm">
                            Profit Check :{" "}
                            {toFixed(
                                this.state.fullTbData?.total_profit,
                                this.props.decimalNumber || 5
                            )}
                        </div>
                        <div className="flex-4 flex items-center justify-start text-vsm lg:text-sm ">
                            Date : {this.state.fullTbData?.date_time}
                        </div>
                    </div>
                    <canvas ref={(el) => (this.chartRef = el)}></canvas>
                    <div
                        className="w-full min-h-8 flex-1 flex justify-around text-vsm lg:text-sm items-center mt-2 md:mt-0 bg-gradient-to-r from-secondaryRed to-secondaryGreen  rounded-md
                    ">
                        <div className="flex flex-row-reverse justify-center h-full cursor-pointer">
                            <div className="flex justify-center items-center ml-2">Previous</div>
                            <img
                                src="/icons/full_arrow_left_icon.png"
                                onClick={this.getPreviousData}
                                className="max-w-8 max-h-8 "
                                alt="previous"
                            />{" "}
                        </div>
                        <div className="flex flex-row-reverse justify-center h-full cursor-pointer ">
                            {" "}
                            <div className="flex py-1 px-3 w-full  z-10 ">
                                <SelectInput
                                    selectFunction={(value) => {
                                        const isRenko = value.optionId === 1 ? true : false;
                                        this.props.updateChartDataFormatAction(isRenko);
                                    }}
                                    selectHolder={{
                                        styles: {},
                                        className: `min-w-18 max-w-15 md:max-w-18 flex-end flex-1 flex min-h-7  z-50 `
                                    }}
                                    selectOptions={{
                                        holderStyle: {},
                                        className:
                                            "flex text-sm justify-center max-w-25 relative z-50 flex-1 ",
                                        selectedValue: {
                                            defaultText: this.props.isChartDataFormatRenko
                                                ? "RENKO"
                                                : "CANDLE",
                                            style: { fontSize: 12 },
                                            className: `${
                                                this.props.isDarkMode
                                                    ? "bg-secondaryDark"
                                                    : "bg-secondaryLight"
                                            } text-sm flex-1 min-h-7 primaryBorder flex justify-center items-center cursor-pointer text-vsm md:min-h-9`
                                        },
                                        list: {
                                            holderStyle: {},
                                            className: `absolute top-8 w-full z-90`,
                                            options: [
                                                {
                                                    optionId: 1,
                                                    option: "RENKO"
                                                },
                                                {
                                                    optionId: 2,
                                                    option: "CANDLE"
                                                }
                                            ],
                                            singleOption: {
                                                divStyle: {
                                                    zIndex: 100
                                                },
                                                divClassName: `${
                                                    this.props.isDarkMode
                                                        ? "bg-secondaryDark border-1"
                                                        : "bg-tertiaryLight"
                                                } text-sm z-50 min-h-7 mt-2 primaryBoxShadow flex items-center justify-center cursor-pointer md:min-h-9 max-w-15 md:max-w-18`,
                                                labelStyle: {
                                                    cursor: "pointer",
                                                    fontSize: 10
                                                },
                                                labelClassName: "",
                                                inputStyle: {
                                                    display: "none"
                                                }
                                            }
                                        }
                                    }}
                                    optionName="option"
                                    isEditable={!this.props.isRenkoCreationOn}
                                />
                            </div>{" "}
                        </div>
                        <div className="flex justify-center h-full cursor-pointer">
                            <div className="flex justify-center items-center mr-2">Next</div>
                            <img
                                src="/icons/full_right_arrow_icon.png"
                                onClick={this.getNextData}
                                className="max-w-8 max-h-8 "
                                alt="next"
                            />{" "}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateChartDataFormatAction: (isRenko) => dispatch(updateChartDataFormatAction(isRenko))
    };
};

const mapStateToProps = (state) => {
    const {
        persistedReducer: { currenciesList, currentSide, currentCurrencyId, isDarkMode }
    } = state;
    const {
        currencyConfigs: { renkoPipes },
        walletConfig: { leverage, quantity }
    } = currenciesList[currentCurrencyId][currentSide.side];
    const {
        operations: { isRenkoCreationOn, isBinanceOn, isModelOn },
        marketPrice,
        startRenkoDate,
        totalStatus: { isPositionOpen },
        isChartDataFormatRenko,
        decimalNumber
    } = currenciesList[currentCurrencyId];
    return {
        currentSide,
        currentCurrencyId,
        renkoPipes,
        isRenkoCreationOn,
        isModelOn,
        isBinanceOn,
        marketPrice,
        isDarkMode,
        startRenkoDate,
        isPositionOpen,
        leverage,
        quantity,
        isChartDataFormatRenko,
        decimalNumber
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(DisplayRenkoSlingData);
